/* eslint-disable @typescript-eslint/no-explicit-any */
import AppConfig from 'aem-libs-react-ts/src/types/app-config';



import { HttpClient } from '../../../utility/HttpClient';
import { IGetWidgetInstanceParamsRequest, IGetWidgetParamsRequest } from './types';


export const widgetParams = (config: AppConfig) => {
  const apiBase = 'v1/portalComponents/aem'
  const httpClient = new HttpClient(config.webApi, apiBase)

  return {
    getWidgetParams: <T>(request: IGetWidgetParamsRequest) => {
      return httpClient.get<T>('/params/' + request.appName)
    },
    getWidgetInstanceParams: <T>(request: IGetWidgetInstanceParamsRequest) => {
      return httpClient.get<T>('/component/' + request.instanceId)
    }
  }
}
